import React from "react";
import { createRoot } from "react-dom/client";
import "./errorTooltip.scss";

let errorTooltipRoot = null;

const ErrorTooltip = {
	loadTaxonomyString: (className) => {
		ErrorTooltip.errorWrapper(className);
	},

	closeOpenTaxonomyString: (event) => {
		const errorContainer = document.querySelectorAll(`.workbook_error_tooltip`);
		if (errorContainer) {
			errorContainer.forEach((node) => {
				// If user clicks outside the element, hide it!
				if (node.classList.contains("open--string")) {
					node.classList.remove("open--string");
				}
			});
		}
	},

	updateTaxonomyString: (event, value, dimensions, className) => {
		if (errorTooltipRoot) {
			errorTooltipRoot.unmount();
		}
		const errorContainer = document.querySelector(`.${className}`);
		errorContainer.classList.add("open--string");
		errorContainer.setAttribute("style", `top: ${event.clientY + window.scrollY + 15}px; left: ${event.clientX - 18}px; position: absolute;`);
		errorTooltipRoot = createRoot(errorContainer);
		errorTooltipRoot.render(ErrorTooltip.buildDynamicString(dimensions, value));
	},

	errorWrapper: (className) => {
		const body = document.querySelector("body");
		const errorContainer = document.querySelector(`.${className}`);
		if (!errorContainer) {
			const errorWrapper = document.createElement("DIV");
			errorWrapper.classList.add(className, "errortooltip__container");
			body.appendChild(errorWrapper);
		}
	},

	buildDynamicString: (dimensions, value) => {
		return (
			<div className="flex__container flex--ai--c">
				<span className="errorTooltip--string">{value || "N/A"}</span>
			</div>
		);
	}
};

export default ErrorTooltip;
